import Immutable from 'seamless-immutable'
import * as actions from './actions'

const initialState = Immutable.from({
  title: '',
  action: null,
  error: false,
})

const navigation = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.SET_PAGE_TITLE:
      if (error) {
        return state.set('error', true)
      }
      return state.set('title', payload)
    default:
      return state
  }
}

export default navigation
